import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import { setCustomerDeviceTypeAction } from 'store/app/slice';
import noContextMenuForMobile from 'utils/noContextMenuForMobile';
import getCustomerDeviceType from '../selector/getCustomerDeviceType';
import isMobile from '../selector/isMobile';
import isVerticallyOriented from '../selector/isVerticallyOriented';
import { CustomerDeviceType } from '../types';

const setCustomerDeviceTypeOperation =
  (deviceType: CustomerDeviceType, isVertical: boolean) =>
  (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const currentCustomerDeviceType = getCustomerDeviceType(store);
    const currentCustomerDeviceOrientation = isVerticallyOriented(store);

    if (currentCustomerDeviceType === deviceType && currentCustomerDeviceOrientation === isVertical) {
      return;
    }

    dispatch(
      setCustomerDeviceTypeAction({
        customerDeviceType: deviceType,
        customerDeviceVerticallyOriented: isVertical,
      }),
    );
    // Chrome (Mobile): Prevent showing context menu on long taps on images
    noContextMenuForMobile(isMobile(store));
  };

export default setCustomerDeviceTypeOperation;
